import { combineEpics } from 'redux-observable';

import { CommonEpic } from 'common/types/redux';

import * as api from './earn.api';
import * as epics from './earn.epics';

const epicsCombined: CommonEpic<typeof api> = (action$, state$) =>
  combineEpics(...Object.values(epics))(action$, state$, { api });

export default epicsCombined;
